import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { CartProvider } from "@/context/CartContext";
import { initAnalytics, trackPageView } from "@/lib/analytics";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import WhatsAppButton from "@/components/WhatsAppButton";
import AiChatWidget from "@/components/AiChatWidget";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import Promo from "@/pages/Promo";
import About from "@/pages/About";
import ProductDetail from "@/pages/ProductDetail";
import Checkout from "@/pages/Checkout";
import OrderConfirmation from "@/pages/OrderConfirmation";
import Tracking from "@/pages/Tracking";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminProductEdit from "@/pages/AdminProductEdit";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const AnalyticsTracker = () => {
  const location = useLocation();
  useEffect(() => {
    initAnalytics();
    trackPageView();
  }, [location]);
  return null;
};

const Chrome = ({ children }) => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && (
        <>
          <Navbar />
          <div aria-hidden="true" style={{ height: "var(--header-h, 7.5rem)" }} />
          <WhatsAppButton />
          <AiChatWidget />
        </>
      )}
      {children}
      {!isAdmin && <Footer />}
      <CartDrawer />
    </>
  );
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <CartProvider>
        <BrowserRouter>
          <ScrollManager />
          <AnalyticsTracker />
          <Chrome>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/boutique" element={<Catalog />} />
              <Route path="/promo" element={<Promo />} />
              <Route path="/a-propos" element={<About />} />
              <Route path="/produit/:id" element={<ProductDetail />} />
              <Route path="/commander" element={<Checkout />} />
              <Route path="/commande/:orderNumber" element={<OrderConfirmation />} />
              <Route path="/commande" element={<Navigate to="/suivi" replace />} />
              <Route path="/suivi" element={<Tracking />} />
              <Route path="/paiement/succes" element={<PaymentSuccess />} />
              <Route path="/paiement/annule" element={<PaymentCancel />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/produits/:id" element={<AdminProductEdit />} />
            </Routes>
          </Chrome>
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </CartProvider>
    </div>
  );
}

export default App;
